import { getToken } from "@/utils/index"
import { getAlarmBuildNo } from '@/api/index'
import store from "../store";
import { NEED_LOGIN_ROUTER_NAMES } from "@/constant/index"
import { Message } from "element-ui"
import bus from "@/components/three-scene/Bus"

/**
 * @description 路由导航守卫
 */
let timer = null;
export default (router) => {
    router.beforeEach(async (to, from, next) => {
        if (!store.state.threeLoad) {
            next()
            return
        }
        if (to.name === from.name) {
            next()
            return
        }
        //进行操作
        if (timer) {
            clearInterval(timer);
            timer = null
        }
        let noNeedFocus = ["fifth", "fourth-second", "fourth-first"]
        let noNeedUp = ["fifth", "fourth-second", "fourth-first"]
        if (Object.values(store.state.threeEvent).includes(true)) {
            for (let name of Object.keys(store.state.threeEvent)) {
                if (store.state.threeEvent[name]) {
                    switch (name) {
                        case "intoElevator":
                            bus.emit("lift", false);
                            console.log("离开电梯");
                            break;
                        case "intoPDJ":
                            if (!noNeedUp.includes(to.name)) {
                                bus.emit("changeScene", "up");
                            }
                            console.log("离开配电间");
                            break;
                        case "intoWaterPump":
                            if (!noNeedUp.includes(to.name)) {
                                bus.emit("changeScene", "up");
                            }
                            console.log("离开水泵");
                            break;
                        case "intoFire":
                            bus.emit("openFloorLabel", false);
                            if (!noNeedFocus.includes(to.name)) {
                                bus.emit("back");
                            }
                            console.log("离开消防");
                            break;
                        case "intoJk":
                            bus.emit("openFloorLabel", false);
                            bus.emit("mit", false);
                            if (!noNeedFocus.includes(to.name)) {
                                bus.emit("back");
                            }
                            console.log("离开监控");
                            break;
                        case "intoWarnCenter":
                            bus.emit("hiddenBuildSprite", true);
                            break;
                        case "intoFireUnder":
                            if (!noNeedUp.includes(to.name)) {
                                bus.emit("changeScene", "up");
                            }
                            console.log("离开消防地下");
                            break;
                        case "intoParking":
                            bus.emit("parking", false)
                            console.log("离开停车场");
                            break;
                        case "intoIllumina":
                            bus.emit("light", false)
                            console.log("离开照明");
                            break;
                        case "intoEleCon":
                            bus.emit("openFloorLabel", false);
                            if (!noNeedFocus.includes(to.name)) {
                                bus.emit("back");
                            }
                            console.log("离开电能耗");
                            break;
                        case "intoWaterCon":
                            bus.emit("openFloorLabel", false);
                            if (!noNeedFocus.includes(to.name)) {
                                bus.emit("back");
                            }
                            console.log("离开水能耗");
                            break;
                        case "intoGateway":
                            bus.emit("openFloorLabel", false);
                            if (!noNeedFocus.includes(to.name)) {
                                bus.emit("back");
                            }
                            console.log("离开网关");
                            break;
                        case "intoAirCon":
                            bus.emit("openFloorLabel", false);
                            if (!noNeedFocus.includes(to.name)) {
                                bus.emit("back");
                            }
                            console.log("离开电梯");
                            break;
                        case "intoEnviron":
                            bus.emit("openFloorLabel", false);
                            bus.emit("emp", false);
                            bus.emit("removeDialogs")
                            if (!noNeedFocus.includes(to.name)) {
                                bus.emit("back");
                            }
                            console.log("离开环境监测");
                            break;
                    }
                    store.state.threeEvent[name] = false;
                }
            }
        } else {
            if (!noNeedFocus.includes(to.name)) {
                bus.emit("back");
                console.log("执行聚焦");
            }
        }
        next()

        let map = {
            '/environment': 'HJ',
            '/waterCons': 'WM',
            '/eleCons': 'GD',
            '/equillumina': 'ZM',
            '/firecontrol/0': 'XF',
            '/aircondition': 'KT',
            '/equelevator': 'DT',
            '/gateway': 'WG',
            '/monitoring': 'AF'
        }
        Object.keys(map).forEach(async (item) => {
            if (item == to.path) {
                getAlarm(map[to.path]);
                timer = setInterval(() => {
                    getAlarm(map[to.path]);
                }, 30*60*1000)
            }
        })

    })
}
const getAlarm = async (moduleName) => {
    let res = await getAlarmBuildNo({ module: moduleName })
    if (!res.data) return
    bus.emit('nowPath', res.data)
    bus.emit('nowPath1', res.data)
}